import styled from '@emotion/styled';

// AdvancedSearchLinkWrapper component is used for keyboard highlighting
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const AdvancedSearchLinkWrapper = styled.span({
  display: 'flex',
  width: '100%'
});